import React from 'react';
import Form from '../../components/common/Form';
// import Joi from 'joi-browser';
import toastr from 'toastr';

class PasswordModal extends Form {
    constructor(props) {
        super(props);
        this.state = {
            done: false,
            data: {
                old_password: "",
                new_password: "",
                repeat_new_password: ""
            },
            errors: {}
        };

        toastr.options = {
            closeButton: true,
            positionClass: "toast-bottom-full-width",
            showDuration: "300",
            hideDuration: "1000",
            timeOut: "8000",
            extendedTimeOut: "1000",
        };
    }

    // schema = {
    //     old_password: Joi.string().required().min(3).label("Password"),
    //     new_password: Joi.string().required().min(3).label("New password"),
    //     repeat_new_password:Joi.string().required().min(3).label("Repeat new password")
    // };

    doSubmit = (e) => {
        const {new_password, repeat_new_password} = this.state.data;
        if(new_password !==repeat_new_password)
        {
            toastr.error('Passwords must match.')
        }
        else
        {
            const data = this.state.data;
            this.props.acceptModal(e, data);
        }
    };

    render() {
        let {visible_modal, onClickAway} = this.props;

        return (
            <div id="passwordModal" className="modal" style={visible_modal ? {display: "block"} : {display: "none"}}>
                {/*<div className="modal-content text-center">*/}
                {/*<div className="onboarding-panel">*/}

                {/*    <h1 className="onboarding-title distribution-title text-bold m-m-b"><span>Change Password</span></h1>*/}
                {/*    <div className="form-group m-m-b">*/}

                {/*        {this.renderInput("old_password", "password", "Old password")}*/}
                {/*        {this.renderInput("new_password", "password", "New password")}*/}
                {/*        {this.renderInput("repeat_new_password", "password", "Repeat new password")}*/}
                {/*    </div>*/}
                {/*    <div className="submit-buttons row">*/}
                {/*        <div className="col-md-6">*/}
                {/*            <button disabled={false}*/}
                {/*                    onClick={onClickAway}*/}
                {/*                    name="cancel_password"*/}
                {/*                    id="cancel_password"*/}
                {/*                    type="button"*/}
                {/*                    className='btn-dark-blue'>Cancel</button>*/}
                {/*        </div>*/}
                {/*        <div className="col-md-6 text-right save-submit">*/}
                {/*            <button disabled={false}*/}
                {/*                    name="change_password"*/}
                {/*                    id="change_password"*/}
                {/*                    type="button"*/}
                {/*                    onClick={this.doSubmit}*/}
                {/*                    className='btn-action'>Accept</button>*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*</div>*/}
                {/*</div>*/}

            </div>
        )
    }
}

export default PasswordModal;